<template>
    <section class="dp-layout class-affair-config">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right" v-if="schoolId > 0">
            <div class="header-bar">
                <span class="label">当前学校：</span>
                <span class="value">{{ schoolName || '未命名学校' }}</span>
            </div>
            <el-alert
                title="新增一条材料，填名称和起止，并给每个校区选值周加分项。班主任在这段时间里提交后给班级德育分。德育台账用另一段起止汇总学生评价德育分，并记录班主任赋分。"
                type="info"
                :closable="false"
                show-icon
                class="tip-alert"
            />
            <el-tabs v-model="activeTab">
                <el-tab-pane label="材料时段" name="window">
                    <div class="toolbar">
                        <el-button v-if="hasActionPermission('saveMaterialWindow')" type="primary" size="small" @click="openWindow()">新增</el-button>
                    </div>
                    <el-table :data="windows" v-loading="loadingWindow" border size="small">
                        <el-table-column prop="Title" label="名称" min-width="120" show-overflow-tooltip />
                        <el-table-column label="起止" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.StartDate }} ~ {{ scope.row.EndDate }}</template>
                        </el-table-column>
                        <el-table-column label="加分项" min-width="140" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="campusConfiguredCount(scope.row) > 0"
                                    type="text"
                                    size="mini"
                                    class="campus-cfg-link"
                                    @click="openCampusConfigDialog(scope.row)"
                                >{{ campusConfiguredCount(scope.row) }} 个校区已配置</el-button>
                                <span v-else class="muted-text">未配置</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="提交" min-width="120" align="center">
                            <template slot-scope="scope">{{ scope.row.HasSubmit ? '已有' : '无' }}</template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="120" align="center">
                            <template slot-scope="scope">
                                <el-button v-if="hasActionPermission('saveMaterialWindow')" type="text" size="mini" @click="openWindow(scope.row)">编辑</el-button>
                                <el-button v-if="hasActionPermission('deleteMaterialWindow')" type="text" size="mini" :disabled="scope.row.HasSubmit" @click="removeWindow(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="德育台账时段" name="ledger">
                    <div class="toolbar">
                        <el-button v-if="hasActionPermission('saveLedgerWindow')" type="primary" size="small" @click="openLedger()">新增时段</el-button>
                    </div>
                    <el-table :data="ledgerWindows" v-loading="loadingLedger" border size="small">
                        <el-table-column prop="Title" label="标题" min-width="120" show-overflow-tooltip />
                        <el-table-column label="起止" min-width="120" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.StartDate }} ~ {{ scope.row.EndDate }}</template>
                        </el-table-column>
                        <el-table-column prop="BonusMax" label="赋分上限" min-width="120" align="center">
                            <template slot-scope="scope">{{ scope.row.BonusMax > 0 ? scope.row.BonusMax : '不限' }}</template>
                        </el-table-column>
                        <el-table-column label="台账" min-width="120" align="center">
                            <template slot-scope="scope">{{ scope.row.HasLedger ? '已有' : '无' }}</template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="120" align="center">
                            <template slot-scope="scope">
                                <el-button v-if="hasActionPermission('saveLedgerWindow')" type="text" size="mini" @click="openLedger(scope.row)">编辑</el-button>
                                <el-button v-if="hasActionPermission('deleteLedgerWindow')" type="text" size="mini" :disabled="scope.row.HasLedger" @click="removeLedger(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </section>
        <section class="dp-right" v-else>
            <div class="empty-tip">请在左侧选择学校</div>
        </section>

        <el-dialog title="材料时段" :visible.sync="windowVisible" width="980px" :close-on-click-modal="false">
            <el-form label-width="90px" size="small">
                <el-form-item label="名称">
                    <el-input v-model="windowForm.Title" maxlength="100" placeholder="如 2026秋季学期计划" />
                </el-form-item>
                <el-form-item label="起止">
                    <el-date-picker v-model="windowForm.Range" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" style="width:100%" />
                </el-form-item>
                <el-form-item label="加分项">
                    <el-table :data="windowForm.CampusItems" border size="mini">
                        <el-table-column prop="CampusName" label="校区" width="160" show-overflow-tooltip />
                        <el-table-column label="启用" width="80" align="center">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.Enabled" />
                            </template>
                        </el-table-column>
                        <el-table-column label="加分项" min-width="420">
                            <template slot-scope="scope">
                                <el-cascader
                                    v-model="scope.row.DutyInspectItemId"
                                    :options="itemTrees[String(scope.row.CampusId)] || []"
                                    :props="cascaderProps"
                                    clearable
                                    filterable
                                    style="width:100%"
                                />
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="hint block-hint">启用后该校区班主任才能提交。分值用加分项上的分，加分项尽量专供班务。</div>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="windowVisible = false">取消</el-button>
                <el-button type="primary" size="small" :loading="saving" @click="saveWindow">保存</el-button>
            </div>
        </el-dialog>

        <!-- 加分项校区配置明细（对齐组织「查看管理员」弹窗）。创建于 2026-10-20 -->
        <el-dialog
            :title="'加分项配置 - ' + (campusCfgRow.Title || '')"
            :visible.sync="campusCfgVisible"
            width="720px"
            :close-on-click-modal="false"
            append-to-body
            custom-class="ca-campus-cfg-dialog"
        >
            <div class="kq-view-head">
                <div class="kq-view-head-item">
                    <span class="label">材料：</span>
                    <span class="val">{{ campusCfgRow.Title || '-' }}</span>
                </div>
                <div class="kq-view-head-item">
                    <span class="label">起止：</span>
                    <span class="val">{{ campusCfgRow.StartDate || '-' }} ~ {{ campusCfgRow.EndDate || '-' }}</span>
                </div>
                <div class="kq-view-head-item">
                    <span class="label">已配置：</span>
                    <span class="val count-badge">{{ campusConfiguredCount(campusCfgRow) }} 个校区</span>
                </div>
            </div>
            <div class="kq-view-table-wrap">
                <el-table :data="campusCfgList" size="small" max-height="360" border stripe>
                    <el-table-column type="index" label="序号" width="60" align="center" />
                    <el-table-column prop="CampusName" label="校区" min-width="140" show-overflow-tooltip />
                    <el-table-column label="状态" width="90" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="!scope.row.Enabled" size="mini" type="info">未启用</el-tag>
                            <el-tag v-else-if="scope.row.DutyInspectItemInvalid" size="mini" type="warning">已失效</el-tag>
                            <el-tag v-else-if="scope.row.DutyInspectItemId" size="mini" type="success">已配置</el-tag>
                            <el-tag v-else size="mini" type="info">未选加分项</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="加分项" min-width="260" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.DutyInspectItemInvalid" class="warn-text">配置已失效</span>
                            <span v-else-if="scope.row.DutyInspectItemPath || scope.row.DutyInspectItemName">
                                {{ scope.row.DutyInspectItemPath || scope.row.DutyInspectItemName }}
                                <template v-if="scope.row.DutyInspectItemScore != null">
                                    （{{ formatDutyScore(scope.row.DutyInspectItemScore) }}分）
                                </template>
                            </span>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <el-button size="small" @click="campusCfgVisible = false">关闭</el-button>
                <el-button
                    v-if="hasActionPermission('saveMaterialWindow')"
                    type="primary"
                    size="small"
                    @click="editFromCampusCfg"
                >去编辑</el-button>
            </div>
        </el-dialog>

        <el-dialog title="台账时段" :visible.sync="ledgerVisible" width="520px" :close-on-click-modal="false">
            <el-form label-width="100px" size="small">
                <el-form-item label="学期">
                    <el-select v-model="ledgerForm.SemesterId" clearable placeholder="可选，用于带出日期" style="width:100%" @change="onSemesterChange">
                        <el-option v-for="s in semesters" :key="s.Id" :label="s.SemesterName" :value="s.Id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="ledgerForm.Title" maxlength="100" />
                </el-form-item>
                <el-form-item label="起止">
                    <el-date-picker v-model="ledgerForm.Range" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始" end-placeholder="结束" style="width:100%" />
                </el-form-item>
                <el-form-item label="赋分上限">
                    <el-input-number v-model="ledgerForm.BonusMax" :min="0" :precision="2" :step="1" />
                    <span class="hint">0 表示不限制</span>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="ledgerVisible = false">取消</el-button>
                <el-button type="primary" size="small" :loading="saving" @click="saveLedger">保存</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import { getButtonList } from '../../promissionRouter';
import {
    getClassAffairWindows, saveClassAffairWindow, deleteClassAffairWindow,
    getClassAffairItemConfigs, getClassAffairAdditionItemTree,
    getClassAffairLedgerWindows, getClassAffairSemesterOptions, saveClassAffairLedgerWindow, deleteClassAffairLedgerWindow
} from '../../api/modules/classAffair';

export default {
    name: 'ClassAffairConfig',
    components: { DepartmentPane },
    data() {
        return {
            schoolId: 0,
            schoolName: '',
            buttonList: [],
            activeTab: 'window',
            windows: [],
            ledgerWindows: [],
            semesters: [],
            itemTrees: {},
            loadingWindow: false,
            loadingLedger: false,
            saving: false,
            windowVisible: false,
            ledgerVisible: false,
            campusCfgVisible: false,
            campusCfgRow: {},
            campusCfgList: [],
            windowForm: { Id: 0, Title: '', Range: [], CampusItems: [] },
            ledgerForm: { Id: 0, Title: '', SemesterId: null, Range: [], BonusMax: 0 },
            cascaderProps: { value: 'id', label: 'name', children: 'children', emitPath: false }
        };
    },
    created() {
        this.buttonList = getButtonList(this.$route.path) || [];
    },
    methods: {
        hasActionPermission(func) {
            if (!this.buttonList || !this.buttonList.length) return true;
            return this.buttonList.some(button => button.Func === func);
        },
        treeNodeClick(data) {
            this.schoolId = data && data.value ? data.value : 0;
            this.schoolName = data && data.label ? data.label : '';
            this.reload();
        },
        reload() {
            if (!this.schoolId) return;
            this.loadWindows();
            this.loadLedgers();
            this.loadSemesters();
        },
        /**
         * 加分项分值展示。创建于 2026-10-20
         */
        formatDutyScore(v) {
            const n = Number(v);
            if (Number.isNaN(n)) return v;
            return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
        },
        /**
         * 已启用且已选有效加分项的校区数。创建于 2026-10-20
         */
        campusConfiguredCount(row) {
            const items = (row && row.CampusItems) || [];
            return items.filter(item =>
                item && item.Enabled && item.DutyInspectItemId && !item.DutyInspectItemInvalid
            ).length;
        },
        /**
         * 打开校区加分项明细弹窗。创建于 2026-10-20
         */
        openCampusConfigDialog(row) {
            this.campusCfgRow = row || {};
            this.campusCfgList = (row && row.CampusItems) ? row.CampusItems.slice() : [];
            this.campusCfgVisible = true;
        },
        /**
         * 从明细弹窗跳转编辑。创建于 2026-10-20
         */
        editFromCampusCfg() {
            const row = this.campusCfgRow;
            this.campusCfgVisible = false;
            if (row && row.Id) this.openWindow(row);
        },
        toCampusForm(item) {
            return {
                CampusId: item.CampusId,
                CampusName: item.CampusName,
                Enabled: !!item.Enabled,
                DutyInspectItemId: item.DutyInspectItemId ? String(item.DutyInspectItemId) : null
            };
        },
        async loadWindows() {
            this.loadingWindow = true;
            try {
                const res = await getClassAffairWindows({ schoolId: this.schoolId });
                this.windows = res.data && res.data.success ? (res.data.response || []) : [];
                if (res.data && !res.data.success) this.$message.error(res.data.msg || '加载失败');
            } finally {
                this.loadingWindow = false;
            }
        },
        async loadLedgers() {
            this.loadingLedger = true;
            try {
                const res = await getClassAffairLedgerWindows({ schoolId: this.schoolId });
                this.ledgerWindows = res.data && res.data.success ? (res.data.response || []) : [];
            } finally {
                this.loadingLedger = false;
            }
        },
        async loadSemesters() {
            const res = await getClassAffairSemesterOptions({ schoolId: this.schoolId });
            this.semesters = res.data && res.data.success ? (res.data.response || []) : [];
        },
        async openWindow(row) {
            let campuses = row && row.CampusItems ? row.CampusItems : [];
            if (!campuses.length) {
                const res = await getClassAffairItemConfigs({ schoolId: this.schoolId });
                campuses = res.data && res.data.success ? (res.data.response || []) : [];
            }
            this.windowForm = {
                Id: row ? row.Id : 0,
                Title: row ? (row.Title || '') : '',
                Range: row ? [row.StartDate, row.EndDate] : [],
                CampusItems: campuses.map(item => this.toCampusForm(item))
            };
            this.itemTrees = {};
            this.windowVisible = true;
            campuses.forEach(item => this.loadTree(item.CampusId));
        },
        async loadTree(campusId) {
            const res = await getClassAffairAdditionItemTree({ schoolId: this.schoolId, campusId: campusId || 0 });
            const nodes = res.data && res.data.success ? (res.data.response || []) : [];
            this.$set(this.itemTrees, String(campusId), this.normalizeTree(nodes));
        },
        async saveWindow() {
            if (!this.windowForm.Title || !this.windowForm.Title.trim()) {
                this.$message.warning('请填写名称');
                return;
            }
            if (!this.windowForm.Range || this.windowForm.Range.length !== 2) {
                this.$message.warning('请选择起止日期');
                return;
            }
            this.saving = true;
            try {
                const res = await saveClassAffairWindow({
                    Id: this.windowForm.Id,
                    SchoolId: this.schoolId,
                    Title: this.windowForm.Title.trim(),
                    StartDate: this.windowForm.Range[0],
                    EndDate: this.windowForm.Range[1],
                    CampusItems: (this.windowForm.CampusItems || []).map(item => ({
                        CampusId: item.CampusId,
                        Enabled: !!item.Enabled,
                        DutyInspectItemId: item.DutyInspectItemId || 0
                    }))
                });
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '已保存');
                    this.windowVisible = false;
                    this.loadWindows();
                } else {
                    this.$message.error((res.data && res.data.msg) || '保存失败');
                }
            } finally {
                this.saving = false;
            }
        },
        removeWindow(row) {
            this.$confirm('删除该时段？', '提示', { type: 'warning' }).then(async () => {
                const res = await deleteClassAffairWindow({ SchoolId: this.schoolId, Id: row.Id });
                if (res.data && res.data.success) {
                    this.$message.success('已删除');
                    this.loadWindows();
                } else {
                    this.$message.error((res.data && res.data.msg) || '删除失败');
                }
            }).catch(() => {});
        },
        normalizeTree(nodes) {
            if (!Array.isArray(nodes)) return [];
            return nodes.map(n => {
                const children = this.normalizeTree(n.Children || n.children);
                const nodeType = n.NodeType || n.nodeType;
                const isLeaf = nodeType === 'item' || !children.length;
                const rawName = n.Name != null ? n.Name : n.name;
                const score = n.ScoreValue != null ? n.ScoreValue : n.scoreValue;
                // 叶子显示分值，便于配置时确认。创建于 2026-10-20
                const name = isLeaf && score != null && score !== ''
                    ? `${rawName}（${score}分）`
                    : rawName;
                return {
                    id: String(n.Id != null ? n.Id : n.id),
                    name,
                    children: isLeaf ? undefined : children
                };
            });
        },
        openLedger(row) {
            this.ledgerForm = row
                ? { Id: row.Id, Title: row.Title || '', SemesterId: row.SemesterId || null, Range: [row.StartDate, row.EndDate], BonusMax: row.BonusMax || 0 }
                : { Id: 0, Title: '', SemesterId: null, Range: [], BonusMax: 0 };
            this.ledgerVisible = true;
        },
        onSemesterChange(id) {
            const row = this.semesters.find(s => s.Id === id);
            if (row && row.StartDate && row.EndDate) {
                this.ledgerForm.Range = [row.StartDate, row.EndDate];
                if (!this.ledgerForm.Title) this.ledgerForm.Title = row.SemesterName;
            }
        },
        async saveLedger() {
            if (!this.ledgerForm.Range || this.ledgerForm.Range.length !== 2) {
                this.$message.warning('请选择起止日期');
                return;
            }
            this.saving = true;
            try {
                const res = await saveClassAffairLedgerWindow({
                    Id: this.ledgerForm.Id,
                    SchoolId: this.schoolId,
                    Title: this.ledgerForm.Title,
                    SemesterId: this.ledgerForm.SemesterId || 0,
                    StartDate: this.ledgerForm.Range[0],
                    EndDate: this.ledgerForm.Range[1],
                    BonusMax: this.ledgerForm.BonusMax || 0
                });
                if (res.data && res.data.success) {
                    this.$message.success(res.data.msg || '已保存');
                    this.ledgerVisible = false;
                    this.loadLedgers();
                } else {
                    this.$message.error((res.data && res.data.msg) || '保存失败');
                }
            } finally {
                this.saving = false;
            }
        },
        removeLedger(row) {
            this.$confirm('删除该台账时段？', '提示', { type: 'warning' }).then(async () => {
                const res = await deleteClassAffairLedgerWindow({ SchoolId: this.schoolId, Id: row.Id });
                if (res.data && res.data.success) {
                    this.$message.success('已删除');
                    this.loadLedgers();
                } else {
                    this.$message.error((res.data && res.data.msg) || '删除失败');
                }
            }).catch(() => {});
        }
    }
};
</script>

<style scoped>
.header-bar { margin-bottom: 12px; }
.label { color: #909399; }
.value { font-weight: 600; }
.tip-alert { margin-bottom: 12px; }
.toolbar { margin-bottom: 10px; }
.warn-text { color: #E6A23C; }
.muted-text { color: #909399; font-size: 13px; }
.campus-cfg-link { font-weight: 500; }
.hint { margin-left: 8px; color: #909399; font-size: 12px; }
.block-hint { margin: 8px 0 0; }
.empty-tip { padding: 80px 0; text-align: center; color: #909399; }
.kq-view-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 10px 16px;
    margin-bottom: 12px;
}
.kq-view-head-item { font-size: 13px; color: #334155; }
.kq-view-head-item .label { color: #64748b; }
.kq-view-head-item .val { font-weight: 500; color: #0f172a; }
.kq-view-head-item .count-badge {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 12px;
    font-size: 12px;
    background-color: #eff6ff;
    color: #2563eb;
    font-weight: 600;
}
.kq-view-table-wrap { margin-top: 4px; }
</style>
